<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technician" title="Products" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="row mb-4">
                                <div class="col-md-10">
									<div class="mm-cart-text">
										<div class="col-md-6">
											<table class="product_table">
												<thead style="font-size: medium;">
													<tr>
														<th>Technician Name</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: right;">Technician 1</td>
													</tr> 
												</thead>
											</table>
										</div>
                                    </div>
								</div>
							    <div class="col-md-2">
                                    <router-link :to="{ name: 'add_technician_product' }" class="btn btn-primary float-end">Add Product</router-link>
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" >
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Product Name</th>
											<th>Stock</th>
											<th>Last Updated On</th> 
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody>
                                        <tr align="center">
                                            <td>1</td>
                                            <td>
												GPS Device
											</td>
											<td>100</td>
											<td>11 Jun 2025 11:45:54</td>
                                            <td>
												<button class="btn btn-info btn-sm me-2 mb-2" @click="updateStock()">Update Stock</button><br>                
												<router-link :to="{ name: 'technician_product_logs' }" class="btn btn-primary btn-sm me-2 mb-2">Stock Logs</router-link>
                                            </td>
                                        </tr>
                                        <tr align="center">
                                            <td>2</td>
                                            <td>
												Speed Governer
											</td>
											<td>70</td>
											<td>11 Jun 2025 11:34:44</td>
                                            <td>
												<button class="btn btn-info btn-sm me-2 mb-2" @click="updateStock()">Update Stock</button><br>                    
												<router-link :to="{ name: 'technician_product_logs' }" class="btn btn-primary btn-sm me-2 mb-2">Stock Logs</router-link>
                                            </td>
                                        </tr>
                                      
                                    </tbody>
								</table>
							</div>

							<!----pagination starts --->
							<!-- <nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchNotifications(page.url + '&limit=' + listing_length + '&type=' + type + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> -->
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="type">
								<option value="">--Select--</option>
								<option value="1">Add Stock</option>
								<option value="2">Remove Stock</option>
							</select>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Stock<span class="text-danger">*</span></label>
                        	<input v-model="stock" class="form-control" rows="3"/>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Update Stock",
				button_title: "Update",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                type: "",
				stock: "",
				
         		// delete: false,
         		// active_page_url: null,
			};
		},
		created() {

		},
		methods: {
			
			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            updateStock() {
                this.errors = {};
                this.type = "";
				this.stock = "";
				this.modal_title = "Update Stock";
				this.button_title = "Update";
				this.showModal();
            },
			
			clearForm() {
				this.edit = false;
                this.type = "";
				this.stock = "";
				this.modal_title = "Update Stock";
				this.button_title = "Update";
				this.errors = {};
			},


		},
	};
</script>